module.exports = __webpack_public_path__ + "img/meeting-room.832cdf18.svg";